import { IReportElement } from "@monorepo/reports/src/views/FundsReportsView/types/reportElement";

export const convertApiItemToUi = (item: IReportElement): IReportElement => ({
  ...item,
  deleted: item.deleted,
});
